CamposExtraFirmaCtrl.$inject = [];

export default function CamposExtraFirmaCtrl() {

    var campExtFirma = this;
    campExtFirma.claseRow = issetAndNotEmpty(campExtFirma.claseRow) ? campExtFirma.claseRow == 'true' : true;

    campExtFirma.firmaImg = null;

    if (typeof campExtFirma.campoExtra.valor != 'undefined' && campExtFirma.campoExtra.valor != null
        && campExtFirma.campoExtra.valor != '') campExtFirma.firmaImg = campExtFirma.campoExtra.valor;

    campExtFirma.hasError = false;

    campExtFirma.cambiaFirma = function (data) {
        campExtFirma.campoExtra.valor = data;
        campExtFirma.hasError = data == null;
        campExtFirma.campoExtra.changed = true;
    };
}